/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_CopiedInputs */

const en_admin_ai_chat_copied = /** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied`)
};

const de_admin_ai_chat_copied = /** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopiert`)
};

const es_admin_ai_chat_copied = /** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiado`)
};

const fr_admin_ai_chat_copied = /** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copié`)
};

const nl_admin_ai_chat_copied = /** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gekopieerd`)
};

/** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */
const it_admin_ai_chat_copied = en_admin_ai_chat_copied;

/** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_copied = en_admin_ai_chat_copied;

/** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */
const pl_admin_ai_chat_copied = en_admin_ai_chat_copied;

/** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */
const hu_admin_ai_chat_copied = en_admin_ai_chat_copied;

/** @type {(inputs: Admin_Ai_Chat_CopiedInputs) => LocalizedString} */
const ro_admin_ai_chat_copied = en_admin_ai_chat_copied;

/**
* | output |
* | --- |
* | "Copied" |
*
* @param {Admin_Ai_Chat_CopiedInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_copied = /** @type {((inputs?: Admin_Ai_Chat_CopiedInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_CopiedInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_copied(inputs)
	if (locale === "de") return de_admin_ai_chat_copied(inputs)
	if (locale === "es") return es_admin_ai_chat_copied(inputs)
	if (locale === "fr") return fr_admin_ai_chat_copied(inputs)
	if (locale === "nl") return nl_admin_ai_chat_copied(inputs)
	if (locale === "it") return it_admin_ai_chat_copied(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_copied(inputs)
	if (locale === "pl") return pl_admin_ai_chat_copied(inputs)
	if (locale === "hu") return hu_admin_ai_chat_copied(inputs)
	return ro_admin_ai_chat_copied(inputs)
});
export { admin_ai_chat_copied as "admin.ai_chat.copied" }